import DashboardLatestStatementsRow from '@Scenes/RightsholderScene/RightsholderDashboard/DashboardLatestStatementsCard/DashboardLatestStatementsRow'
import Navigation from '@App/navigation'
import React from 'react'
import { PayeeRoyalties } from '@Entities/statements/payee-royalties'
import { observer } from 'mobx-react'

interface DashboardLatestStatementTableProps {
    royalties: PayeeRoyalties[]
    usagePeriod: string
    rightsholderIpId: number
}

const DashboardLatestStatementTable = ({
    royalties,
    usagePeriod,
    rightsholderIpId,
}: DashboardLatestStatementTableProps) => (
    <div className="latest-statements-links">
        {royalties.map((royalty) => (
            <DashboardLatestStatementsRow
                payeeName={royalty.payeeName}
                statementsLink={Navigation.rightholder.royalties.statement(rightsholderIpId, royalty.ipId, usagePeriod)}
                paymentStatus={royalty.status}
                paymentAmount={royalty.paymentAmount}
                key={royalty.payeeName}
            />
        ))}
    </div>
)

export default observer(DashboardLatestStatementTable)
